<div class="container-fluid" style="margin-top:55px;" *ngIf="system === 'tert'">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
      <div class="custom-card">
        <div class="card-body">
          <h5 class="section-header">SEMESTER RESULT</h5>
          <div class="custom-card">
            <div class="p-3" *ngIf="paid === false">
              <p>
                In order to view your result, A fee of &#8358;{{ resultPaymentAmount }} is required,
                payment also includes a 1.6% payment integration charge of &#8358;{{ resultPaymentCharge }},
                resulting in a total of &#8358;{{ resultPaymentAmount + resultPaymentCharge }}.
              </p>
              <button mat-raised-button (click)="payForResult()">Pay for Result</button>
            </div>
            <p *ngIf="paid != true && paid != false" class="pt-2 pl-2">Loading...</p>

            <p *ngIf="paid === true && dataLength == 0" class="pt-2 pl-2">No result yet</p>
            <mat-tab-group (selectedTabChange)="tabChange($event)" *ngIf="paid === true">

              <mat-tab label="{{x.session_year}} | {{x.semester}}" *ngFor="let x of details">
                <div class="container-fluid" *ngIf="!x.eligible">
                  <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                      <div class="row px-3 py-20">
                        <div class="col-12">
                          <h3 class="text-black/30 text-center mb-2">
                            <span class="text-3xl">{{x.percentageString}}</span>
                            <small class="text-[1rem] ml-1">Paid</small>
                          </h3>
                          <p class="text-danger mb-2 max-w-sm mx-auto text-center">{{ x.eligibilityMessage}}</p>
                          <div class="text-center mb-3">
                            <button mat-dialog-close color="primary" mat-raised-button
                              routerLink="/home/pay-tuition">Make Payment</button>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>

                <div id="toBePrinted" *ngIf="x.eligible">
                  <!-- <div>
                      <p><strong>{{x.session_year}}({{x.semester}}) RESULT</strong>
                    </div> -->
                  <table class="table">
                    <tr>
                      <th>Course</th>
                      <th>Title</th>
                      <th>Mark</th>
                      <th>Unit</th>
                      <th>Grade</th>
                      <th>Total</th>
                      <th>Remarks</th>
                    </tr>
                    <tr *ngFor="let detail of x.tab" [ngSwitch]="true">
                      <td style="font-family: roboto-bold; color: #4b4b4b">{{detail.title | uppercase}}</td>
                      <td>{{detail.s_desc | uppercase}}</td>
                      <td>{{detail.marks}}</td>
                      <td>{{detail.unit}}</td>
                      <td>{{ detail._grade | uppercase }}</td>
                      <td> {{ detail._point }}</td>
                      <td>{{ detail._comment | uppercase }}</td>
                    </tr>
                  </table>

                  <div class="table-responsive">
                    <table style="width:100%;">
                      <tr>
                        <th colspan="12">RESULT SUMMARY</th>
                      </tr>
                      <tr>
                        <td>Semester Total Units</td>
                        <td>{{x.tot}}</td>
                        <td>Semester Total Points</td>
                        <td>{{x.attainedGrade}}</td>
                        <td>Semester GPA</td>
                        <td>{{x.attainedGrade/x.tot | number:'1.2-2'}}</td>
                      </tr>
                      <tr>
                        <td>Cummulative Total Units</td>
                        <td>{{x.cummulativeTotal}}</td>
                        <td>Cummulative Total Points</td>
                        <td>{{x.cummulativeTotalAttainable}}</td>
                        <td>Cummulative G.P.A</td>
                        <td>{{x.cummulativeTotalAttainable/x.cummulativeTotal | number:'1.2-2'}}</td>
                      </tr>
                    </table>

                  </div>
                </div>
              </mat-tab>
            </mat-tab-group>
          </div>

          <nav class="navbar navbar-expand-sm fixed-bottom" id="nav-bottom">
            <ul class="navbar-nav ml-auto">
              <!-- <button type="button" matTooltip="Previous" 
                        mat-button color="primary" ><fa name="chevron-circle-left"></fa>
                      </button>
                      <button type="button" matTooltip="Next" 
                        mat-button color="primary" ><fa name="chevron-circle-right"></fa>
                      </button> -->
              <button type="button" matTooltip="Print" *ngIf="company?.allow_portal_result_print"
                style="background-color:#20273B;" class="floating-btn" color="primary" (click)="print()"><mat-icon
                  style="font-size:1.6em;">print</mat-icon>
              </button>
            </ul>
          </nav>

        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid" style="margin-top:55px;" *ngIf="system === 'psec'">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
      <div class="custom-card">
        <div class="card-body">
          <h5 class="section-header">STUDENT'S RESULT</h5>
          <div class="custom-card">
            <p *ngIf="dataLength == 0">No result</p>
            <mat-tab-group (selectedTabChange)="tabChange($event)">

              <mat-tab label="{{x.session_year}} | {{x.semester}}" *ngFor="let x of details">
                <div id="toBePrinted">
                  <!-- {{x.termd_id}} termd  -->

                  <table class="table">
                    <tr>
                      <th>Subject</th>
                      <th
                        *ngIf="controlCA1 == true && controlCA2 == false || controlCA2 == true && controlCA1 == false">
                        {{ca1Name}}
                      </th>
                      <th *ngIf="controlCA1 == true && controlCA2 == true">
                        {{ca1Name}}
                      </th>
                      <th *ngIf="controlCA1 == true && controlCA2 == true">
                        {{ca2Name}}
                      </th>
                      <th>{{examName}}</th>
                      <th>Total</th>
                      <th>Grade</th>
                      <th>Remarks</th>
                    </tr>
                    <tr *ngFor="let detail of x.tab" [ngSwitch]="true">
                      <td style="font-family: roboto-bold; color: #4b4b4b">{{detail.name | uppercase}}</td>
                      <td *ngIf="controlCA1 == true && controlCA2 == false">{{detail.ca1}}</td>
                      <td *ngIf="controlCA1 == false && controlCA2 == true">{{detail.ca2}}</td>
                      <td *ngIf="controlCA1 == true && controlCA2 == true">{{detail.ca1}}</td>
                      <td *ngIf="controlCA1 == true && controlCA2 == true">{{detail.ca2}}</td>
                      <td> {{ detail.exam }}</td>
                      <td>{{ detail.marks }}</td>
                      <td>{{ detail._grade }}</td>
                      <td>{{ detail._comment }}</td>

                    </tr>
                  </table>


                </div>
              </mat-tab>
            </mat-tab-group>
          </div>

          <nav class="navbar navbar-expand-sm fixed-bottom" id="nav-bottom">
            <ul class="navbar-nav ml-auto" *ngIf="company?.allow_portal_result_print">

              <button *ngIf="system == 'uni'" type="button" matTooltip="Print" style="background-color:#20273B;"
                class="floating-btn" color="primary" (click)="print()"><mat-icon
                  style="font-size:1.6em;">print</mat-icon>
              </button>

              <button *ngIf="system == 'psec'" type="button" matTooltip="Print" [matMenuTriggerFor]="cmenu"
                style="background-color:#20273B;" class="floating-btn" color="primary"><mat-icon
                  style="font-size:1.6em;">print</mat-icon>
              </button>
              <mat-menu #cmenu="matMenu">
                <div>
                  <button class="btn btn-block" style="
                          border: none !important;
                          border-radius: 0 !important;
                          outline: none !important;
                        " mat-menu-item (click)="printPsec()">
                    Report Sheet
                  </button>
                </div>
                <div>
                  <button class="btn btn-block" style="
                          border: none !important;
                          border-radius: 0 !important;
                          outline: none !important;
                        " mat-menu-item (click)="printTermReport()">
                    Aggregate Sheet
                  </button>
                </div>
              </mat-menu>

            </ul>
          </nav>

        </div>
      </div>
    </div>
  </div>
</div>

<div id="singlePrint"
  style="width: 100%;visibility: hidden;display: none; font-size: 12px; font-family: Arial, Helvetica, sans-serif !important"
  *ngIf="studentReport.length>0 && company?.allow_portal_result_print">

  <table style="width: 100%;">
    <tr>
      <td>
        <img src="{{company_logo}}" style="  width:80px;height:80px" />

      </td>
      <td>
        <strong style="font-size: 2em">{{company_name | uppercase}}</strong>
        <div>
          <i>{{company_address}}</i>
        </div>
      </td>
    </tr>
    <tr>
      <td colspan="2">
        <div style='width:100%;border-top:2px solid black;margin-top:3px'>
        </div>
      </td>
    </tr>
  </table>
  <form id="box1">
    <fieldset>
      <legend>Student Info</legend>
      <table width="100%" border="0" cellspacing="0" cellpadding="0">
        <tr>
          <td width="135" rowspan="6" valign="top"><img name="" class="border" src="{{studentReport[0].passport}}"
              onerror="this.src='assets/images/man.png'" width="98" height="81" alt="Passport missing" /></td>
          <td width="148"><b>Student Name</b></td>
          <td width="292"><span class="name" style="text-transform:uppercase;">
              <b>{{studentReport[0].lastname | uppercase}}</b> {{studentReport[0].firstname | uppercase}} <span
                *ngIf="studentReport[0].middlename">{{studentReport[0].middlename | uppercase}}</span></span></td>
          <td width="100"><b>Student ID</b>.</td>
          <td width="130">{{studentReport[0].matric_no}}</td>
          <td width="32">&nbsp;</td>
          <td width="32">&nbsp;</td>
          <td width="44">&nbsp;</td>
        </tr>
        <tr>
          <td><b>Number In Class</b></td>
          <td>{{fetchForAll ? totalReportArr.length : reportArr.length}}</td>
          <td><b>Gender</b></td>
          <td>{{studentReport[0].gender | uppercase}}</td>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td><b>Class</b></td>
          <td>{{studentReport[0].category | uppercase}} - {{studentReport[0].name | uppercase}} -
            {{studentReport[0].tag | uppercase}}</td>
          <td *ngIf="showDOB"><b>DOB</b></td>
          <td *ngIf="showDOB">{{formatDate(studentReport[0].date_of_birth)}}</td>
        </tr>
        <tr align="center" valign="bottom" style="background: white; color: black; font-weight: bolder">
          <td colspan="6">
            <font size="3">{{studentReport[0].term | uppercase}} REPORT SHEET FOR
              {{studentReport[0].session_year | uppercase}} ACADEMIC SESSION</font>
          </td>
          <td>&nbsp;</td>
        </tr>
      </table>
    </fieldset>
  </form>
  <div id="box2">
    <table width="100%" height="78" border="0" cellpadding="0" cellspacing="0">
      <tr>
        <td width="420">
          <fieldset>
            <legend>Attendance</legend>
            <table width="100%">
              <tr>
                <td width="143" align="left">Times School Open:</td>
                <td width="72">{{currentTerm.open_days}}</td>
                <td width="91">Times Present</td>
                <td width="47">{{studentReport[0].skills[0].attendance}}</td>
              </tr>
              <tr>
                <td align="left">Next Term Begins:</td>
                <td>
                  <span *ngIf="currentTerm && currentTerm.open_days">{{
                       currentTerm.next_term_begins
                     }}</span>
                </td>
                <td>Student Ave.</td>
                <td style="font-weight: bold">{{studentReport[0].ave | number:'1.0-2'}}</td>
              </tr>
            </table>
          </fieldset>
        </td>
        <td width="470">
          <fieldset>
            <legend> Academic Performance (Key Grades)</legend>
            <ul type="none" style="font-size: 15pt; padding: 3px !important; margin-top: -7px">
              <li *ngFor="let grade  of gradeArr;let i = index;"
                style="text-transform: uppercase;text-align: center; width: 32%; float: left;">
                <span *ngIf="grade[0].max_score == 0" class="pl-5">0</span>
                <span *ngIf="grade[0].max_score != 0"><span>{{grade[0].min_score}} - {{grade[0].max_score}}</span>
                  <strong style="margin-left: 20px">{{grade[0].grade}}</strong>

                </span>
              </li>
            </ul>

          </fieldset>
        </td>
      </tr>
    </table>
  </div>
  <br>
  <div id="box3" *ngIf="studentReport.length > 0">
    <table width="100%" border="1" style="border-collapse: collapse !important">
      <tr>
        <th style="text-align: left;padding-left: 10px;">
          Subjects
        </th>
        <th *ngIf="controlCA1 == true && controlCA2 == false ||
                                controlCA2 == true && controlCA1 == false">
          {{ca1Name}}
        </th>
        <th *ngIf="controlCA1 == true && controlCA2 == true">
          {{ca1Name}}
        </th>
        <th *ngIf="controlCA1 == true && controlCA2 == true">
          {{ca2Name}}
        </th>
        <th *ngIf="controlExam == true">
          {{examName}}
        </th>
        <th>
          Total
        </th>
        <th>
          Grade
        </th>
        <th *ngIf="showSubjectPosition">
          S. Position
        </th>
        <th>
          Remark
        </th>
      </tr>
      <tr style="font-weight: bold">
        <td style="text-align: left;padding-left: 10px">Marks obtainable</td>
        <td style="text-align: center;" *ngIf="controlCA1 == true && controlCA2 == false">{{this.obtainable.ca1}}</td>
        <td style="text-align: center;" *ngIf="controlCA1 == false && controlCA2 == true">{{this.obtainable.ca2}}</td>
        <td style="text-align: center;" *ngIf="controlCA1 == true && controlCA2 == true">{{this.obtainable.ca1}}</td>
        <td style="text-align: center;" *ngIf="controlCA1 == true && controlCA2 == true">{{this.obtainable.ca2}}</td>
        <td style="text-align: center;">{{this.obtainable.exam}}</td>
        <td style="text-align: center;">{{this.obtainable.total}}</td>
        <td style="text-align: center;">&nbsp;</td>
        <td style="text-align: center;" *ngIf="showSubjectPosition">&nbsp;</td>
        <td style="text-align: center;">&nbsp;</td>
      </tr>
      <tr *ngFor="let result of studentReport[0].results">
        <td style="text-align: left;padding-left: 10px">{{result.title| uppercase}}</td>
        <td style="text-align: center;" *ngIf="controlCA1 == true && controlCA2 == false">{{result.ca1}}</td>
        <td style="text-align: center;" *ngIf="controlCA1 == false && controlCA2 == true">{{result.ca2}}</td>
        <td style="text-align: center;" *ngIf="controlCA1 == true && controlCA2 == true">{{result.ca1}}</td>
        <td style="text-align: center;" *ngIf="controlCA1 == true && controlCA2 == true">{{result.ca2}}</td>
        <td style="text-align: center;">{{result.exam == 0 ? '-' : result.exam}}</td>
        <td style="text-align: center;">{{result.total}}</td>
        <td style="text-align: center;">{{result.grade | uppercase}}</td>
        <td style="text-align: center;" *ngIf="showSubjectPosition">{{result.sub_position}}</td>
        <td style="padding-left:25px">{{result.comment | uppercase}}</td>
      </tr>
    </table>
  </div>
  <br>
  <table *ngIf="showClassPosition" border="1"
    style="border-collapse: collapse; width: 100%; margin-top: 15px; margin-bottom: 10px">
    <tr>
      <td style="padding: 10px;">POSITION IN CLASS: <strong>{{studentReport[0].class_position}}</strong></td>
    </tr>
  </table>
  <br>
  <table width="100%" height="157" border="0" cellpadding="0" cellspacing="0">
    <tr>
      <td width="323" valign="top">
        <fieldset>
          <legend>Skills</legend>
          <table width="100%" border="1" style="border-collapse: collapse !important" cellpadding="0" cellspacing="0"
            class="skills" *ngFor="let skill of studentReport[0].skills">
            <tr>
              <td width="93%" style="padding-left: 5px">1.Hand Writing </td>
              <td width="7%" align="center">{{skill.handwriting}}</td>
            </tr>
            <tr>
              <td style="padding-left: 5px">2.Fluency</td>
              <td align="center">{{skill.fluency}}</td>
            </tr>
            <!-- <tr>
                       <td style="padding-left: 5px">3.Games</td>
                       <td align="center">{{skill.games}}</td>
                     </tr> -->
            <tr>
              <td style="padding-left: 5px">3.Sport</td>
              <td align="center">{{skill.sport}}</td>
            </tr>
            <tr>
              <td style="padding-left: 5px">4.Handling of tools in lab &amp; workshop </td>
              <td align="center">{{skill.h_of_tools}}</td>
            </tr>
            <!-- <tr>
                       <td style="padding-left: 5px">6.Gymnastics</td>
                       <td align="center">{{skill.gym}}</td>
                     </tr> -->
            <!-- <tr>
                       <td style="padding-left: 5px">7.Drawing &amp; painting </td>
                       <td align="center">{{skill.drawing}}</td>
                     </tr> -->
            <!-- <tr>
                       <td height="20" style="padding-left: 5px">8.Crafts</td>
                       <td align="center">{{skill.craft}}</td>
                     </tr> -->
            <!-- <tr>
                       <td height="20" style="padding-left: 5px">9.Musical skills </td>
                       <td align="center">{{skill.musical_skills}}</td>
                     </tr> -->
          </table>
        </fieldset>
      </td>
      <td width="" valign="top">
        <fieldset>
          <legend>Behaviour</legend>
          <table width="100%" border="1" style="border-collapse: collapse !important" cellpadding="0" cellspacing="0"
            class="skills" *ngFor="let skill of studentReport[0].skills">
            <!-- <tr>
                       <td width="59%" style="padding-left: 5px">1.Punctuality</td>
                       <td width="4%" align="center" style="padding-left: 5px">{{skill.punctuality}}</td>
                     </tr> -->
            <tr>
              <!-- <td style="padding-left: 5px">2.Attendance in class </td> -->
              <!-- <td style="padding-left: 5px">2.Attendance </td>
                       <td  style="padding-left: 5px"align="center">{{skill.b_attendance}}</td> -->
              <!-- <td style="padding-left: 5px">1.Sense of responsibility </td>
                       <td align="center">{{skill.sense_of_res}}</td> -->
            </tr>
            <tr>
              <!-- <td style="padding-left: 5px">2.Reliabilty</td>
                       <td style="padding-left: 5px" align="center">{{skill.reliability}}</td> -->
              <td style="padding-left: 5px">1.Punctuality</td>
              <td style="padding-left: 5px" align="center">{{skill.punctuality}}</td>
              <!-- <td style="padding-left: 5px"></td>
                       <td style="padding-left: 5px"></td> -->
              <!-- <td style="padding-left: 5px">12.Attentiveness</td> -->
              <!-- <td style="padding-left: 5px" align="center">{{skill.attentiveness}}</td> -->
            </tr>
            <tr>
              <td style="padding-left: 5px">2.Neatness</td>
              <td style="padding-left: 5px" align="center">{{skill.neatness}}</td>
              <!-- <td style="padding-left: 5px">13.Initiative</td>
                       <td style="padding-left: 5px" align="center">{{skill.initiative}}</td> -->
            </tr>
            <tr>
              <td style="padding-left: 5px">3.Politeness</td>
              <td style="padding-left: 5px" align="center">{{skill.politeness}}</td>
              <!-- <td style="padding-left: 5px">14.Organisation ability </td>
                       <td style="padding-left: 5px" align="center">{{skill.organisation_ab}}</td> -->
            </tr>
            <tr>
              <!-- <td style="padding-left: 5px">5.Honesty</td>
                       <td style="padding-left: 5px" align="center">{{skill.honesty}}</td> -->
              <!-- <td style="padding-left: 5px">15.Perseverance</td>
                       <td style="padding-left: 5px" align="center">{{skill.perseverance}}</td> -->
            </tr>
            <tr>
              <td style="padding-left: 5px">4.Relationship with other student </td>
              <td style="padding-left: 5px" align="center">{{skill.rel_with_student}}</td>
              <!-- <td style="padding-left: 5px">&nbsp;</td>
                       <td style="padding-left: 5px">&nbsp;</td> -->
            </tr>
            <tr>
              <!-- <td style="padding-left: 5px">7.Relationship with staff </td>
                       <td style="padding-left: 5px" align="center">{{skill.rel_with_staff}}</td> -->
              <td style="padding-left: 5px">5. Organization Ability</td>
              <td style="padding-left: 5px">{{skill.organisation_ab}}</td>
            </tr>
            <!-- <tr>
                       <td style="padding-left: 5px" height="20">9.Self control </td>
                       <td style="padding-left: 5px" align="center">{{skill.self_control}}</td>
                       <td style="padding-left: 5px">&nbsp;</td>
                       <td style="padding-left: 5px">&nbsp;</td>
                     </tr> -->
          </table>
        </fieldset>
      </td>
    </tr>
  </table>
  <br />
  <fieldset>
    <legend>Comments</legend>
    <table width="837" border="0" cellspacing="0" cellpadding="0">
      <tr>
        <td style="padding-top: 10px !important" width="157">Class Teacher's Comment </td>
        <td style="padding-top: 10px !important" width="674">
          <p style="border: 1px solid grey; padding: 5px">{{studentReport[0].comments[0].ctcomment}}</p>
        </td>
      </tr>
      <!-- <tr>
               <td style="padding-top: 10px !important">H. Master's Comment </td>
               <td style="padding-top: 10px !important"><p style="border: 1px solid grey; padding: 5px">{{studentReport[0].comments[0].hmcomment}}</p></td>
               </tr> -->
      <tr>
        <td style="padding-top: 10px !important">Principal's Comment</td>
        <td style="padding-top: 10px !important">
          <p style="border: 1px solid grey; padding: 5px">{{studentReport[0].comments[0].pcomment}}</p>
        </td>
      </tr>
      <tr>
        <td>&nbsp; </td>
        <td>&nbsp;</td>
      </tr>
    </table>
  </fieldset>
  <table width="100%" cellpadding="0" cellspacing="0" style="margin-top: 100px">
    <tr>
      <td width="20%">&nbsp;</td>
      <td width="20%">
        <p align="center"><img src="{{studentReport[0].signs[0].psignature}}" width="120" height="40"></p>
        <p style="margin-top: 20px; border-top: 1px solid grey; padding-top: 5px; text-align: center">Principal</p>
      </td>
      <td width="20%">&nbsp;</td>
      <td width="20%">
        <p align="center"><img src="{{studentReport[0].signs[0].ctsignature}}" width="120" height="40"></p>
        <p style="margin-top: 20px; border-top: 1px solid grey; padding-top: 5px; text-align: center">Class Teacher</p>
      </td>
      <td width="20%">&nbsp;</td>
    </tr>

  </table>
  <footer style="position: fixed;bottom:0;right: 0;">
    <p style="letter-spacing: 5px;"> <i>EDOZZIER</i></p>
  </footer>
</div>

<div id="termReport" style="width: 100%; visibility: hidden; display: none; margin: 0"
  *ngIf="studentTermReport.length>0 && company?.allow_portal_result_print">
  <div>
    <div id="box2">
      <table width="100%" height="78" border="0" cellpadding="0" cellspacing="0">
        <tr>
          <td width="420">
            <fieldset>
              <legend>Attendance</legend>
              <table width="100%">
                <tr>
                  <td width="143" align="left">Times School Open:</td>
                  <td width="72">{{ currentTerm.open_days }}</td>
                  <td width="91">Times Present</td>
                  <td width="47">
                    {{ studentTermReport[0].skills.attendance }}
                  </td>
                </tr>
                <tr>
                  <td align="left">Next Term Begins:</td>
                  <td>{{ currentTerm.next_term_begins }}</td>
                  <td>Student Ave.</td>
                  <td style="font-weight: bold">
                    {{ studentTermReport[0].ave | number : "1.0-2" }}
                  </td>
                </tr>
              </table>
            </fieldset>
          </td>

          <td width="470">
            <fieldset>
              <legend>Academic Performance (Key Grades)</legend>
              <ul type="none" style="
                  font-size: 15pt;
                  padding: 3px !important;
                  margin-top: -7px;
                ">
                <li *ngFor="let grade of gradeArr; let i = index" style="
                    text-transform: uppercase;
                    text-align: center;
                    width: 32%;
                    float: left;
                  ">
                  <span *ngIf="grade[0].max_score == 0" class="pl-5">0</span>
                  <span *ngIf="grade[0].max_score != 0">
                    <span>{{ grade[0].min_score }} - {{ grade[0].max_score }}</span>
                    <strong style="margin-left: 20px">{{
                      grade[0].grade
                    }}</strong>
                  </span>
                </li>
              </ul>
            </fieldset>
          </td>
        </tr>
      </table>
    </div>
    <!-- <table border="1" style="width: 100%; border-collapse: collapse;">
          <thead>
            <tr>
              <th align="left" style="padding-left: 5px;">Attendance</th>
              <th  align="left"  style="padding-left: 5px;">Term Dates</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td  style="padding-left: 5px;">Times School Opens = </td>
              <td  style="padding-left: 5px;">Current Term Ends = {{currentTerm.ends}}</td>
            </tr>
            <tr>
              <td  style="padding-left: 5px;">Times Present = </td>
              <td  style="padding-left: 5px;">New Term Begins = {{currentTerm.next_term_begins}}</td>
            </tr>
          </tbody>
        </table> -->

    <table border="1" style="width: 100%; border-collapse: collapse; margin-top: 7px">
      <tbody *ngIf="gradeArr.length > 0">
        <tr>
          <td style="font-weight: bold">Range:</td>
          <td *ngFor="let grade of gradeArr" align="center">
            {{ grade.min_score }} - {{ grade.max_score }}
          </td>
        </tr>
        <tr>
          <td style="font-weight: bold">Grade:</td>
          <td *ngFor="let grade of gradeArr" align="center">
            {{ grade.grade }}
          </td>
        </tr>
        <tr>
          <td style="font-weight: bold"><small>Remark: </small></td>
          <td *ngFor="let grade of gradeArr" align="center">
            <small> {{ grade.comment }} </small>
          </td>
        </tr>
      </tbody>
    </table>


    <table border="1" style="width: 100%; border-collapse: collapse;margin-top: 7px;">
      <thead>
        <tr>
          <th style="width: 7%"> Subject </th>
          <th style="width: 7%" *ngIf="controlCA1 == true "> {{ca1Name}} <br /> </th>
          <th style="width: 7%" *ngIf=" controlCA2 == true"> {{ca2Name}} <br /> </th>
          <th style="width: 7%"> {{examName}} <br /> </th>
          <th style="width: 7%"> Total </th>
          <th style="width: 7%"
            *ngIf="studentTermReport[0].subjects[0].t1available || studentTermReport[0].subjects[1].t1available"> 1-Term
          </th>
          <th style="width: 7%"
            *ngIf="studentTermReport[0].subjects[0].t2available || studentTermReport[0].subjects[1].t2available"> 2-Term
          </th>
          <th style="width: 7%"
            *ngIf="studentTermReport[0].subjects[0].t3available || studentTermReport[0].subjects[1].t3available"> 3-Term
          </th>
          <th style="width: 7%"> Average </th>
          <th style="width: 7%"> Grade </th>
          <th style="width: 7%" *ngIf="showSubjectPosition"> Position </th>
          <th style="width: 7%"> Teacher's Remark </th>
        </tr>
      </thead>
      <tbody style="font-size: 10pt !important;">
        <tr *ngFor="let weight of studentTermReport[0].subjects" [style.color]="weight.grade_color">
          <td style="padding-left: 15px !important" class="col-md-3 font-bold ">{{weight.title | uppercase}}
          </td>
          <td style="padding-left: 15px !important" class="col-md-1 pl-4 h6" *ngIf="controlCA1 == true"><span
              *ngIf="weight.current_weight"> {{weight.current_weight.ca1 != '0' ? weight.current_weight.ca1 : '-' }}
            </span> <span *ngIf="!weight.current_weight">-</span></td>
          <td style="padding-left: 15px !important" class="col-md-1 pl-4 h6" *ngIf="controlCA2 == true"><span
              *ngIf="weight.current_weight"> {{weight.current_weight.ca2 != '0' ? weight.current_weight.ca2 : '-' }}
            </span> <span *ngIf="!weight.current_weight">-</span></td>
          <td style="padding-left: 15px !important" class="col-md-1 pl-4 h6"><span *ngIf="weight.current_weight">
              {{weight.current_weight.exam != '0' ? weight.current_weight.exam : '-' }} </span> <span
              *ngIf="!weight.current_weight">-</span></td>
          <td style="padding-left: 15px !important" class="col-md-1 pl-4 h6"><span *ngIf="weight.current_weight">
              {{weight.current_weight.total != '0' ? weight.current_weight.total : '-' }} </span> <span
              *ngIf="!weight.current_weight">-</span></td>
          <td style="padding-left: 15px !important" class="col-md-1 text-center  h6"
            *ngIf="studentTermReport[0].subjects[0].t1available || studentTermReport[0].subjects[1].t1available">
            {{weight.weighted_arr[0].total != '0' ? weight.weighted_arr[0].total : '-'}}
          </td>
          <td style="padding-left: 15px !important" class="col-md-1 text-center  h6"
            *ngIf="studentTermReport[0].subjects[0].t2available || studentTermReport[0].subjects[1].t2available">
            {{weight.weighted_arr[1].total != '0' ? weight.weighted_arr[1].total : '-'}}

          </td>
          <td style="padding-left: 15px !important" class="col-md-1 text-center  h6"
            *ngIf="studentTermReport[0].subjects[0].t3available || studentTermReport[0].subjects[1].t3available">
            {{weight.weighted_arr[2].total != '0' ? weight.weighted_arr[2].total : '-'}}

          </td>
          <td style="padding-left: 15px !important" class="col-md-1 text-center  h6">{{weight.average}} </td>
          <td style="padding-left: 15px !important; text-transform: capitalize" class="col-md-1 text-center  h6">
            {{weight.grade}} </td>
          <td style="padding-left: 15px !important" class="col-md-1 text-center  h6" *ngIf="showSubjectPosition">
            {{weight.sub_position}} </td>
          <td style="padding-left: 15px !important; text-transform: capitalize"
            class="col-md-2 text-left pl-5 font-bold ">{{weight.comment}} </td>
        </tr>
        <!-- <tr *ngFor="let sub of studentTermReport[0].subjects; let i = index">
              <td style="padding-left: 5px; width: 40%;">
                {{ sub.title | uppercase }}
              </td>
              <td  class="col-md-1 text-center  h6" *ngIf="sub.termW1 != 0"  align="center"
              style="width: 7%;">
                {{sub.termW1}}
              </td>
              <td  class="col-md-1 text-center  h6" *ngIf="sub.termW1 == 0"  align="center"
              style="width: 7%;">
                  0
              </td>
              <td  class="col-md-1 text-center  h6" *ngIf="sub.termW2 != 0"  align="center"
              style="width: 7%;">
                  {{sub.termW2}}
              </td>
              <td  class="col-md-1 text-center  h6" *ngIf="sub.termW2 == 0"  align="center"
              style="width: 7%;">
                  0
              </td>
              <td  class="col-md-1 text-center  h6" *ngIf="sub.termW3 != 0"  align="center"
              style="width: 7%;">
                  {{sub.termW3}}
              </td>
              <td  class="col-md-1 text-center  h6" *ngIf="sub.termW3 == 0"  align="center"
              style="width: 7%;">
                  0
              </td>

              <td align="center">{{ sub.total }}</td>
              <td align="center" style="width: 7%;">{{ sub.grade }}</td>
              <td style="width: 5%;" align="center">{{sub.sub_position}}</td>

              <td  style="width: 17%;padding-left: 5px;">{{ sub.comment }}</td>
            </tr> -->
      </tbody>
    </table>
    <table *ngIf="showClassPosition" border="1" style="
        border-collapse: collapse;
        width: 100%;
        margin-top: 15px;
        margin-bottom: 10px;
      ">
      <tr>
        <td style="padding: 10px">
          POSITION IN CLASS:
          <strong>{{ studentTermReport[0].class_position }}</strong>
        </td>
      </tr>
    </table>
    <table width="100%" height="157" border="0" cellpadding="0" cellspacing="0">
      <tr>
        <td width="323" valign="top">
          <fieldset>
            <legend>Skills</legend>
            <table width="100%" border="1" style="border-collapse: collapse !important" cellpadding="0" cellspacing="0"
              class="skills">
              <tr>
                <td width="93%" style="padding-left: 5px">1.Hand Writing</td>
                <td width="7%" align="center">
                  {{ studentTermReport[0].skills.handwriting }}
                </td>
              </tr>
              <tr>
                <td style="padding-left: 5px">2.Fluency</td>
                <td align="center">
                  {{ studentTermReport[0].skills.fluency }}
                </td>
              </tr>
              <!-- <tr>
                  <td style="padding-left: 5px">3.Games</td>
                  <td align="center">{{skill.games}}</td>
                </tr> -->
              <tr>
                <td style="padding-left: 5px">3.Sport</td>
                <td align="center">{{ studentTermReport[0].skills.sport }}</td>
              </tr>
              <tr>
                <td style="padding-left: 5px">
                  4.Handling of tools in lab &amp; workshop
                </td>
                <td align="center">
                  {{ studentTermReport[0].skills.h_of_tools }}
                </td>
              </tr>
              <!-- <tr>
                  <td style="padding-left: 5px">6.Gymnastics</td>
                  <td align="center">{{skill.gym}}</td>
                </tr> -->
              <!-- <tr>
                  <td style="padding-left: 5px">7.Drawing &amp; painting </td>
                  <td align="center">{{skill.drawing}}</td>
                </tr> -->
              <!-- <tr>
                  <td height="20" style="padding-left: 5px">8.Crafts</td>
                  <td align="center">{{skill.craft}}</td>
                </tr> -->
              <!-- <tr>
                  <td height="20" style="padding-left: 5px">9.Musical skills </td>
                  <td align="center">{{skill.musical_skills}}</td>
                </tr> -->
            </table>
          </fieldset>
        </td>
        <td width="" valign="top">
          <fieldset>
            <legend>Behaviour</legend>
            <table width="100%" border="1" style="border-collapse: collapse !important" cellpadding="0" cellspacing="0"
              class="skills">
              <!-- <tr>
                  <td width="59%" style="padding-left: 5px">1.Punctuality</td>
                  <td width="4%" align="center" style="padding-left: 5px">{{skill.punctuality}}</td>
                </tr> -->
              <tr>
                <!-- <td style="padding-left: 5px">2.Attendance in class </td> -->
                <!-- <td style="padding-left: 5px">2.Attendance </td>
                  <td  style="padding-left: 5px"align="center">{{skill.b_attendance}}</td> -->
                <!-- <td style="padding-left: 5px">1.Sense of responsibility </td>
                  <td align="center">{{studentTermReport[0].behavior.sense_of_res}}</td> -->
              </tr>
              <tr>
                <!-- <td style="padding-left: 5px">2.Reliabilty</td>
                  <td style="padding-left: 5px" align="center">{{skill.reliability}}</td> -->
                <td style="padding-left: 5px">1.Punctuality</td>
                <td style="padding-left: 5px" align="center">
                  {{ studentTermReport[0].behavior.punctuality }}
                </td>
                <!-- <td style="padding-left: 5px"></td>
                  <td style="padding-left: 5px"></td> -->
                <!-- <td style="padding-left: 5px">12.Attentiveness</td> -->
                <!-- <td style="padding-left: 5px" align="center">{{skill.attentiveness}}</td> -->
              </tr>
              <tr>
                <td style="padding-left: 5px">2.Neatness</td>
                <td style="padding-left: 5px" align="center">
                  {{ studentTermReport[0].behavior.neatness }}
                </td>
                <!-- <td style="padding-left: 5px">13.Initiative</td>
                  <td style="padding-left: 5px" align="center">{{skill.initiative}}</td> -->
              </tr>
              <tr>
                <td style="padding-left: 5px">3.Politeness</td>
                <td style="padding-left: 5px" align="center">
                  {{ studentTermReport[0].behavior.politeness }}
                </td>
                <!-- <td style="padding-left: 5px">14.Organisation ability </td>
                  <td style="padding-left: 5px" align="center">{{skill.organisation_ab}}</td> -->
              </tr>
              <tr>
                <!-- <td style="padding-left: 5px">5.Honesty</td>
                  <td style="padding-left: 5px" align="center">{{studentTermReport[0].behavior.honesty}}</td> -->
                <!-- <td style="padding-left: 5px">15.Perseverance</td>
                  <td style="padding-left: 5px" align="center">{{skill.perseverance}}</td> -->
              </tr>
              <tr>
                <td style="padding-left: 5px">
                  4.Relationship with other student
                </td>
                <td style="padding-left: 5px" align="center">
                  {{ studentTermReport[0].behavior.rel_with_student }}
                </td>
                <!-- <td style="padding-left: 5px">&nbsp;</td>
                  <td style="padding-left: 5px">&nbsp;</td> -->
              </tr>
              <tr>
                <!-- <td style="padding-left: 5px">7.Relationship with staff </td>
                  <td style="padding-left: 5px" align="center">{{skill.rel_with_staff}}</td> -->
                <td style="padding-left: 5px">5. Organization Ability</td>
                <td style="padding-left: 5px">
                  {{ studentTermReport[0].behavior.organisation_ab }}
                </td>
              </tr>
              <!-- <tr>
                  <td style="padding-left: 5px" height="20">9.Self control </td>
                  <td style="padding-left: 5px" align="center">{{skill.self_control}}</td>
                  <td style="padding-left: 5px">&nbsp;</td>
                  <td style="padding-left: 5px">&nbsp;</td>
                </tr> -->
            </table>
          </fieldset>
        </td>
      </tr>
    </table>

    <fieldset>
      <legend>Comments</legend>
      <table width="837" border="0" cellspacing="0" cellpadding="0">
        <tr>
          <td style="padding-top: 10px !important" width="157">
            Teacher's Comment
          </td>
          <td style="padding-top: 10px !important" width="674">
            <p style="border: 1px solid grey; padding: 5px">
              {{ studentTermReport[0].comments[0].ctcomment }}
            </p>
          </td>
        </tr>
        <!-- <tr>
                  <td style="padding-top: 10px !important">H. Master's Comment </td>
                  <td style="padding-top: 10px !important"><p style="border: 1px solid grey; padding: 5px">{{studentTermReport[0].comments[0].hmcomment}}</p></td>
                  </tr> -->
        <tr>
          <td style="padding-top: 10px !important">Principal's Comment</td>
          <td style="padding-top: 10px !important">
            <p style="border: 1px solid grey; padding: 5px">
              {{ studentTermReport[0].comments[0].pcomment }}
            </p>
          </td>
        </tr>
        <tr>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
        </tr>
      </table>
    </fieldset>
    <table width="100%" cellpadding="0" cellspacing="0" style="margin-top: 70px">
      <tr>
        <td width="20%">&nbsp;</td>
        <td width="20%">
          <p align="center">
            <img src="{{ studentTermReport[0].signs[0].psignature }}" width="120" height="40" />
          </p>
          <p style="
              margin-top: 20px;
              border-top: 1px solid grey;
              padding-top: 5px;
              text-align: center;
            ">
            Principal
          </p>
        </td>
        <td width="20%">&nbsp;</td>
        <td width="20%">
          <p align="center">
            <img src="{{ studentTermReport[0].signs[0].ctsignature }}" width="120" height="40" />
          </p>
          <p style="
              margin-top: 20px;
              border-top: 1px solid grey;
              padding-top: 5px;
              text-align: center;
            ">
            Class Teacher
          </p>
        </td>
        <td width="20%">&nbsp;</td>
      </tr>
    </table>
    <footer style="position: fixed; bottom: 0; right: 0">
      <p style="letter-spacing: 5px"><i>EDOZZIER</i></p>
    </footer>
  </div>
</div>